import React from 'react';
import { Wand2, Loader2, ArrowLeft, Upload } from 'lucide-react';
import { NodeStatus } from '@/types';

interface GenerationPreviewProps {
  isWorking: boolean;
  onGenerate: () => void;
  isUpscaleMode?: boolean;
  onBackToImg2Img?: () => void;
}

export const GenerationPreview: React.FC<GenerationPreviewProps> = ({
  isWorking,
  onGenerate,
  isUpscaleMode = false,
  onBackToImg2Img,
}) => {
  if (isUpscaleMode) {
    return (
      <div className="flex items-center justify-between pt-1">
        {onBackToImg2Img && (
          <button
            onClick={onBackToImg2Img}
            className="flex items-center justify-center w-9 h-9 rounded-xl bg-white/[0.06] border border-white/[0.10] text-white/60 hover:text-white hover:bg-white/10 transition-all duration-200"
            title="返回图生图"
          >
            <ArrowLeft size={16} />
          </button>
        )}
        <button
          onClick={onGenerate}
          disabled={isWorking}
          className={`flex items-center justify-center w-9 h-9 rounded-xl transition-all duration-300 ${
            isWorking
              ? 'bg-white/5 text-white/40 cursor-not-allowed'
              : 'bg-white text-black hover:bg-white/90 hover:scale-105 active:scale-95'
          }`}
        >
          {isWorking ? <Loader2 className="animate-spin" size={16} /> : <Upload size={16} />}
        </button>
      </div>
    );
  }

  return (
    <button
      onClick={onGenerate}
      disabled={isWorking}
      className={`relative flex items-center gap-1.5 px-4 py-2 rounded-xl font-medium text-xs tracking-wide transition-all duration-300 ${
        isWorking
          ? 'bg-white/5 text-white/40 cursor-not-allowed'
          : 'bg-gradient-to-r from-cyan-500 to-blue-500 text-black hover:shadow-lg hover:shadow-cyan-500/20 hover:scale-105 active:scale-95'
      }`}
    >
      {isWorking ? (
        <Loader2 className="animate-spin" size={12} />
      ) : (
        <Wand2 size={12} />
      )}
      <span>{isWorking ? '生成中...' : '生成'}</span>
    </button>
  );
};
